import type { AuthenticationError, ServerAuthenticationEntryPoint} from './types.js';
import {HttpStatus} from "../../http/status.ts";

export const httpStatusEntryPoint = (opts: {
    httpStatus: HttpStatus
}): ServerAuthenticationEntryPoint => {
    return async (exchange, _error: AuthenticationError) => {
        const response = exchange.response;
        response.setStatusCode(opts.httpStatus);
    };
}
